import React from 'react';
import {StyleSheet, View, Text, StyleProp, ViewStyle} from 'react-native';
import {colors} from 'src/assets';
import {Icon} from 'src/components';

type Props = {
  style?: StyleProp<ViewStyle>;
  value: number;
};

export const Likes: React.FC<Props> = ({style, value}) => {
  return (
    <View style={[styles.container, style]}>
      <View style={styles.stars}>
        <Icon
          name={'heart-filled'}
          size={16}
          color={colors.chokuRed}
          style={styles.star}
        />
      </View>
      <Text style={styles.text}>{value}</Text>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  stars: {
    flexDirection: 'row',
  },
  star: {
    marginRight: 1,
  },
  text: {
    marginLeft: 8,
    fontSize: 14,
    fontWeight: 'bold',
    color: colors.chokuGray9,
  },
});
